import { useContext } from "react";
import { AuthContext } from "../Context/ContextProvider/ContextProvider";

export default function useAuth() {
  const auth = useContext(AuthContext);
  return auth;
}
